import { useSetAtom } from "jotai";

import { CheckoutPagesEnum } from "@ts/enums/CheckoutPagesEnum";

import {
    canAddonSelectionSkipAtom,
    checkoutAtom,
    checkoutTotalAmountAtom,
    couponAtom,
    pageQueryParamsAtom,
    userCheckoutStateTokenAtom
} from "@atoms/checkoutAtom";

const useResetAtomicState = () => {
    const setUserCheckoutStateToken = useSetAtom(userCheckoutStateTokenAtom);
    const setCoupon = useSetAtom(couponAtom);
    const setCheckoutTotal = useSetAtom(checkoutTotalAmountAtom);
    const setCanAddonSelectionSkip = useSetAtom(canAddonSelectionSkipAtom);
    const setPageQueryParams = useSetAtom(pageQueryParamsAtom);
    const setCheckout = useSetAtom(checkoutAtom);

    const resetCheckoutAtomicState = ({
        forceResetCheckoutAtom = false
    }: {
        forceResetCheckoutAtom?: boolean;
    } = {}) => {
        if (forceResetCheckoutAtom) {
            setCheckout(prev => ({
                ...prev,
                user: { email: "", firstName: "", receiveOfferNews: false },
                productFamily: null,
                grade: null,
                plan: null,
                addon: null,
                charge: null,
                student: null,
                selectedStudent: null,
                selectedCountry: null,
                selectedState: null,
                nextAttemptPage: CheckoutPagesEnum.USER_INFO_PAGE
            }));
        } else {
            /**
             * We are directly clearing out the session storage entry related to the checkout data.
             * This is used to avoid unwanted state update in the app.
             */
            sessionStorage.removeItem("eukaCheckoutData");
        }

        setUserCheckoutStateToken(null);
        setCoupon(null);
        setCheckoutTotal(0);
        // Related only for the Addon selection page
        setCanAddonSelectionSkip(false);
        setPageQueryParams({
            addon: null,
            coupon: null,
            family: null,
            grade: null,
            plan: null,
            locationState: null,
            skip: null,
            origin: null,
            selectedCountry: null,
            selectedState: null
        });
    };

    return { resetCheckoutAtomicState };
};

export default useResetAtomicState;
